import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLOCO_CONFIG, TRANSLOCO_LOADER, TranslocoModule } from '@ngneat/transloco';
import { TRANSLATION_CONFIG } from './base-translation-config';
import { TranslationRepositoryService } from './translation-repository.service';

@NgModule({
  exports: [TranslocoModule],
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: TRANSLOCO_LOADER, useExisting: TranslationRepositoryService },
    {
      provide: TRANSLOCO_CONFIG,
      useValue: TRANSLATION_CONFIG,
    },
  ],
})
export class TranslationModule {
  constructor(@Optional() @SkipSelf() parentModule: TranslationModule) {
    if (parentModule) {
      throw new Error('TranslationModule is already loaded. Import it in the AppModule only');
    }
  }
}
